import { render, staticRenderFns } from "./Batchdetails.vue?vue&type=template&id=0cfbf182&scoped=true"
import script from "./Batchdetails.vue?vue&type=script&lang=js"
export * from "./Batchdetails.vue?vue&type=script&lang=js"
import style0 from "./Batchdetails.vue?vue&type=style&index=0&id=0cfbf182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfbf182",
  null
  
)

export default component.exports